import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=25efee5e&scoped=true"
import script from "./EntityView.vue?vue&type=script&lang=js"
export * from "./EntityView.vue?vue&type=script&lang=js"
import style0 from "./EntityView.vue?vue&type=style&index=0&id=25efee5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25efee5e",
  null
  
)

export default component.exports